var map = {
	"./agile.svg": 4166,
	"./business.svg": 34981,
	"./coding.svg": 86337,
	"./delivery.svg": 70394,
	"./efficiency.svg": 96274,
	"./package.svg": 44194,
	"./quote.svg": 517,
	"./refactoring.svg": 90984,
	"./sap-dev.svg": 5224,
	"./sap.svg": 95348,
	"./settings.svg": 18904,
	"./space.svg": 74895,
	"./speed.svg": 818,
	"./standard.svg": 969,
	"./trust.svg": 3399,
	"./worker.svg": 40861
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21679;